import React, { FC, useMemo } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import { FormikErrors } from 'formik'
import Typography from '@mui/material/Typography'

const useStyles = makeStyles(theme => ({
  errorContainer: {
    marginTop: theme.spacing(2),
  },
  errorText: {
    color: theme.palette.error.main,
  },
}))

interface FormErrorProps {
  errors: FormikErrors<any>,
  showErrors: boolean,
}

const collectErrors = (errors: FormikErrors<any>): any => {
  const ret = {}
  const collector = (errors: any, ancestorKeys = []) => {
    Object.keys(errors).forEach(key => {
      if(typeof(errors[key]) === 'object') {
        collector(errors[key], ancestorKeys.concat([key]))
      }
      else {
        ret[ancestorKeys.concat([key]).join('.')] = errors[key]
      }
    })
  }
  collector(errors, [])
  return ret
}

const FormErrors: FC<React.PropsWithChildren<FormErrorProps>> = ({
  errors,
  showErrors,
}) => {

  const classes = useStyles()

  const collectedErrors = useMemo(() => {
    return collectErrors(errors)
  }, [
    errors,
  ])

  if(!showErrors || Object.keys(collectedErrors).length <= 0) return null

  return (
    <div className={ classes.errorContainer }>
      <Typography className={ classes.errorText }>
        There are errors in the form:
      </Typography>
      <ul className={ classes.errorText }>
        {
          Object.keys(collectedErrors).map((key, i) => {
            return (
              <li key={ i }>
                <Typography className={ classes.errorText }>
                  { key }: { collectedErrors[key] }
                </Typography>
              </li>
            )
          })
        }
      </ul>
    </div> 
  )
}

export default FormErrors